import { useState } from "react";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import { useMyOrg } from "@/hooks/use-my-org";
import { useModuleCommitments } from "./useModuleOffers";
import { ModuleCommitmentHistory } from "./ModuleOfferContent";
import {
  ModuleOfferPageControls,
  ModuleOfferReadError,
  ModuleOfferWorkspace,
} from "./ModuleOfferWorkspace";

export function ModuleCommitmentsPage() {
  const org = useMyOrg();
  const navigate = useNavigate();
  const [offset, setOffset] = useState(0);
  const orgId = org.kind === "error" ? undefined : org.org?.org_id;
  const query = useModuleCommitments(orgId, { offset });
  return (
    <ModuleOfferWorkspace title="Accepted module offers">
      {org.kind === "loading" || (orgId && query.isPending) ? (
        <Typography role="status">Loading accepted offers…</Typography>
      ) : !orgId || query.isError ? (
        <ModuleOfferReadError onRetry={() => void query.refetch()} />
      ) : query.data ? (
        <>
          <ModuleCommitmentHistory
            page={query.data}
            onOpen={(id) => navigate(`/commercial/agreements/${id}`)}
            onBrowseOffers={() => navigate("/commercial/offers")}
          />
          <ModuleOfferPageControls page={query.data} onOffset={setOffset} />
        </>
      ) : null}
    </ModuleOfferWorkspace>
  );
}
